export const microfrontendConfig = {
  isRuningInChassi: () => !!document.querySelector('#chassi'),
  getBasePath: () => (microfrontendConfig.isRuningInChassi() ? '/' : ''),
};
